/**
 * Specifies the fallback provisions for the hedging party in the determination of the final settlement price.
 * tag: 2599
 * @readonly
 * @enum {number} (int)
 */
export enum ComplexEventPVFinalPriceElectionFallback {
  Close = 0,
  HedgeElection = 1,
}
